import { Font, StyleSheet } from '@react-pdf/renderer'

Font.register({
  family: 'Sohne',
  fonts: [
    { fontWeight: 'normal', src: '/fonts/Sohne/soehne-buch.ttf' },
    { fontWeight: 'bold', src: '/fonts/Sohne/soehne-kraftig.ttf' },
  ],
})

Font.register({
  family: 'Sohne Mono',
  src: '/fonts/Sohne/soehne-mono-buch.ttf',
})

//Disable hiphenation
Font.registerHyphenationCallback((word) => [word])

export const styles = StyleSheet.create({
  document: {
    fontFamily: 'Sohne',
    fontSize: 11,
    color: '#000000',
  },

  // Light letterhead (ENG-32974): title text left, customer logo right,
  // heavy rule underneath — replaces the previous black masthead bar.
  header: {
    alignItems: 'center',
    borderBottomColor: '#000000',
    borderBottomWidth: 2,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    minHeight: 32,
    paddingBottom: 10,
  },

  page: {
    paddingBottom: 72,
    paddingHorizontal: 50,
    paddingTop: 48,
  },

  view: {
    marginTop: 20,
  },

  blueBg: {
    borderColor: '#000000',
    borderWidth: 1,
    height: 150,
    padding: 12,
  },

  facilityName: {
    backgroundColor: '#CDE1FF',
    padding: '2%',
    borderRadius: '10%',
    fontWeight: 'bold',
    color: '#002964',
    textAlign: 'center',
    marginTop: '5%',
    fontSize: 18,
    maxWidth: '40%',
  },

  bold: {
    fontWeight: 'bold',
  },

  mt10: {
    marginTop: 40,
  },

  mt5: {
    marginTop: 20,
  },

  mt2: {
    marginTop: 8,
  },

  mt1: {
    marginTop: 8,
  },

  ml2: {
    marginLeft: 8,
  },

  ml15px: {
    marginLeft: '15px',
  },

  grid: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },

  img: {
    width: '100%',
    height: '100%',
    objectFit: 'fill',
  },

  imgBg: {
    width: '250px',
    height: '250px',
    marginTop: 20,
  },

  normal: {
    fontWeight: 'normal',
  },

  flexRow: {
    display: 'flex',
    flexDirection: 'row',
  },

  footer: {
    position: 'absolute',
    bottom: 24,
    left: 50,
    right: 50,
    height: 30,
    borderColor: '#000000',
    borderWidth: 1,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 8,
    fontFamily: 'Sohne Mono',
    fontSize: 8,
    textTransform: 'uppercase',
  },

  location: {
    marginLeft: '15px',
    width: '100%',
  },

  fs12: {
    fontSize: 12,
  },

  actionBoxTitle: {
    fontSize: 14,
    fontWeight: 'bold',
    marginBottom: 18,
  },

  detailLabel: {
    fontSize: 11,
    width: 135,
  },

  detailValue: {
    fontSize: 11,
    fontWeight: 'bold',
    width: 260,
  },

  editableBox: {
    backgroundColor: '#FFFFFF',
    borderColor: '#000000',
    borderWidth: 1,
    height: 135,
    padding: 10,
  },

  // Gap between the Summary box and the Action title, per the design spec.
  editableBoxGap: {
    marginTop: 7,
  },

  editableFieldsPage: {
    paddingTop: 1,
  },

  // flexShrink so long metadata (timezone, org name) gives way to the
  // fixed branding block instead of overlapping it (yoga defaults to 0).
  footerContent: {
    display: 'flex',
    flexDirection: 'row',
    flexGrow: 1,
    flexShrink: 1,
    overflow: 'hidden',
  },

  footerBranding: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    flexShrink: 0,
    marginLeft: 8,
  },

  footerBrandingLogo: {
    height: 10,
    marginLeft: 4,
    marginRight: 14,
    objectFit: 'contain',
    width: 55,
  },

  footerPageNumber: {
    fontSize: 8,
    textAlign: 'right',
    width: 18,
  },

  footerSeparator: {
    marginHorizontal: 10,
  },

  headerLogo: {
    height: 24,
    objectFit: 'contain',
    objectPosition: 'right',
    width: 130,
  },

  headerTitle: {
    color: '#000000',
    fontFamily: 'Sohne Mono',
    fontSize: 11,
    letterSpacing: 0,
  },

  incidentTitle: {
    fontSize: 16,
    fontWeight: 'bold',
    marginBottom: 22,
    marginTop: 34,
  },

  metadataRow: {
    display: 'flex',
    flexDirection: 'row',
  },

  reportHeaderContent: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },

  reportLogoWrapper: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
  },

  resolutionRow: {
    display: 'flex',
    flexDirection: 'row',
  },

  section: {
    marginTop: 22,
  },

  sectionDivider: {
    borderBottomColor: '#000000',
    borderBottomWidth: 1,
    marginTop: 22,
  },

  sectionTitle: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    marginBottom: 18,
  },

  sectionTitleText: {
    fontSize: 15,
    fontWeight: 'bold',
    marginLeft: 8,
  },

  timelineDate: {
    color: '#A0A0A0',
    fontFamily: 'Sohne Mono',
    fontSize: 10,
    width: 135,
  },

  timelineMessage: {
    fontSize: 10,
    fontWeight: 'bold',
    width: 330,
  },

  timelineRow: {
    display: 'flex',
    flexDirection: 'row',
    marginBottom: 6,
  },

  workflowAnswer: {
    fontSize: 10,
    fontWeight: 'bold',
    width: 190,
  },

  workflowEmptyText: {
    fontSize: 10,
  },

  workflowMeta: {
    color: '#A0A0A0',
    fontFamily: 'Sohne Mono',
    fontSize: 8,
    marginBottom: 2,
    textTransform: 'uppercase',
  },

  workflowQuestion: {
    fontSize: 10,
    width: 285,
  },

  workflowQuestionRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },

  workflowRow: {
    marginBottom: 2,
  },
})
